import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=fa016cb2&scoped=true"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"
import style0 from "./industry.vue?vue&type=style&index=0&id=fa016cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa016cb2",
  null
  
)

export default component.exports